var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, PropSync, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { RolesEnum } from '@/items/Roles';
import { formatDate } from '@/support/String';
import { StudentDocument, StudentDocumentIncludes } from '@/models/StudentDocument';
import ErrorHandler from '@/support/ErrorHandler';
import AddDocumentDialog, { DocumentEntityType } from '@/components/AddDocumentDialog/AddDocumentDialog.vue';
import { Project } from '@/models/Project';
let Documents = class Documents extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isCreatingOrEditingDocument = false;
        this.selectedDocument = null;
        this.DocumentEntityType = DocumentEntityType;
        this.isLoading = true;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        console.log('this.syncedProject: ', this.syncedProject);
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onEditDocument(document) {
        this.selectedDocument = document;
        this.isCreatingOrEditingDocument = true;
    }
    onOpenAddDocumentDialog() {
        this.isCreatingOrEditingDocument = true;
    }
    onCloseAddDocumentDialog() {
        this.isCreatingOrEditingDocument = false;
        this.selectedDocument = null;
    }
    onSubmitted() {
        this.isCreatingOrEditingDocument = false;
        this.selectedDocument = null;
        this.refreshDataTable();
    }
    // #endregion
    // #region Class methods
    openConfirmDeleteDialog(plan) {
        this.$store.dispatch('openDialog', this.dialogOptions(plan));
    }
    dialogOptions(plan) {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.project') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        plan
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get user() {
        return this.$store.state.Auth;
    }
    get canAddPlan() {
        return this.user.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.TEACHER, RolesEnum.TRAINER]);
    }
    get tableOptions() {
        return {
            model: new StudentDocument().include([StudentDocumentIncludes.STATUS, StudentDocumentIncludes.TEACHERS, StudentDocumentIncludes.CREATED_BY, StudentDocumentIncludes.BLOCKS, StudentDocumentIncludes.STUDENT_SUBJECTS]).filter({ project: this.syncedProject.id }),
            sort: {
                key: 'start_at',
                order: 'DESC',
            },
            name: {
                singular: this.$tc('Goal set document'),
                plural: this.$tc('Goal set documents'),
            },
            headers: [
                {
                    text: this.$tc('student_plan.table.title'),
                    value: 'title',
                },
                {
                    text: this.$tc('student_plan.table.description'),
                    value: 'description',
                    transform: (description) => {
                        return description || '-';
                    },
                },
                {
                    text: this.$tc('student_plan.table.start_at'),
                    value: 'start_at',
                    transform: (date) => {
                        return date ? formatDate(date, 'dd-LL-yyyy') : '-';
                    },
                    sortable: {
                        key: 'start_at',
                        order: 'ASC',
                    },
                },
                {
                    text: this.$tc('student_plan.table.end_at'),
                    value: 'end_at',
                    transform: (date) => {
                        return date ? formatDate(date, 'dd-LL-yyyy') : '-';
                    },
                    sortable: {
                        key: 'end_at',
                        order: 'ASC',
                    },
                },
                {
                    text: this.$tc('student_plan.table.status'),
                    value: 'status',
                    transform: (status) => {
                        return (status && status.value) || '-';
                    },
                    sortable: {
                        key: 'status',
                        order: 'ASC',
                    },
                },
            ],
            actions: [
                {
                    type: 'edit',
                    label: 'Download',
                    icon: 'download',
                    action: async (vm, plan) => {
                        if (plan && plan.has_file) {
                            const document = await new StudentDocument().include(StudentDocumentIncludes.FILE).find(plan.id);
                            window.open(document.file || '', '_blank');
                        }
                    },
                    visible: (vm, plan) => {
                        return !!(plan && plan.has_file);
                    },
                },
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'edit',
                    action: (vm, plan) => this.onEditDocument(plan),
                    visible: (vm, plan) => {
                        const currentUser = this.$store.state.Auth.id;
                        const creatorUser = (plan && plan.created_by && plan.created_by.id) || null;
                        const allowedTeachers = ((plan && plan.teachers) || []).filter((teacher) => teacher.permission === 'edit');
                        return currentUser === creatorUser || allowedTeachers.some((teacher) => teacher.user.id === currentUser);
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, plan) => {
                        this.openConfirmDeleteDialog(plan);
                    },
                    visible: (vm, plan) => {
                        return this.$store.state.Auth.id === (plan && plan.created_by && plan.created_by.id);
                    },
                },
            ],
            filters: [],
        };
    }
    get tableVisibility() {
        return {
            checkboxes: false,
        };
    }
};
__decorate([
    PropSync('project', { required: true }),
    __metadata("design:type", typeof (_a = typeof Project !== "undefined" && Project) === "function" ? _a : Object)
], Documents.prototype, "syncedProject", void 0);
Documents = __decorate([
    Component({
        components: {
            DataTable,
            AddDocumentDialog,
        },
    })
], Documents);
export default Documents;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
